import { buildProps, makeRequiredProp, numericProp } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue'
import type TabsContent from '../tabs-content'

export const tabsContentProps = buildProps({
  count: makeRequiredProp(Number),
  inited: Boolean,
  animated: Boolean,
  duration: makeRequiredProp(numericProp),
  swipeable: Boolean,
  lazyRender: Boolean,
  currentIndex: makeRequiredProp(Number),
})

export type TabsContentProps = ExtractPropTypes<typeof tabsContentProps>
export type TabsContentInstance = InstanceType<typeof TabsContent>
